import React from "react";
import LegalShell from "./LegalShell";

export default function CGU() {
  return (
    <LegalShell
      title="Conditions Générales d'Utilisation"
      subtitle="Les présentes CGU régissent l'utilisation de la plateforme DepannRoute par les Clients et les Dépanneurs professionnels."
      lastUpdate="19 février 2026"
      canonical="https://depannroute.com/cgu"
    >
      <h2>1. Objet</h2>
      <p>
        Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») ont pour objet de
        définir les modalités d'accès et d'utilisation de la plateforme DepannRoute (ci-après « la
        Plateforme »). Toute inscription ou utilisation de la Plateforme implique l'acceptation
        pleine et entière des présentes CGU.
      </p>

      <h2>2. Définitions</h2>
      <ul>
        <li><strong>Client :</strong> toute personne physique ou morale qui publie une demande de dépannage.</li>
        <li><strong>Dépanneur :</strong> tout professionnel du dépannage auto inscrit sur la Plateforme.</li>
        <li><strong>Mission :</strong> prestation de remorquage/transport acceptée via la Plateforme.</li>
        <li><strong>Matching :</strong> algorithme de mise en relation aller/retour exclusif de DepannRoute.</li>
      </ul>

      <h2>3. Inscription</h2>
      <p>
        L'inscription est réservée aux personnes majeures ayant la capacité juridique. Le Dépanneur
        s'engage à fournir lors de son inscription ses informations professionnelles exactes
        (SIRET, attestation d'assurance responsabilité civile professionnelle, carte professionnelle
        de dépannage/remorquage en cours de validité).
      </p>

      <h2>4. Obligations des Clients</h2>
      <ul>
        <li>Fournir des informations exactes sur le véhicule et le trajet.</li>
        <li>Être présent ou mandater un représentant sur le lieu d'enlèvement.</li>
        <li>Régler le prix convenu via la Plateforme.</li>
        <li>Évaluer la prestation de manière honnête et objective.</li>
      </ul>

      <h2>5. Obligations des Dépanneurs</h2>
      <ul>
        <li>Disposer d'une assurance professionnelle et d'un véhicule adapté et homologué.</li>
        <li>Respecter le prix, la date et le lieu convenus lors de l'acceptation.</li>
        <li>Se conformer à la réglementation française et européenne sur le transport routier.</li>
        <li>Maintenir une note moyenne minimale de 3/5 pour rester référencé.</li>
      </ul>

      <h2>6. Système de matching aller/retour</h2>
      <p>
        DepannRoute propose un algorithme propriétaire combinant distance (haversine), axe
        géographique (bearing) et fenêtre temporelle pour suggérer des missions complémentaires
        aux Dépanneurs. L'utilisation du matching est <strong>libre et non contraignante</strong> :
        les Dépanneurs restent maîtres d'accepter ou non les missions suggérées.
      </p>

      <h2>7. Avis &amp; notation</h2>
      <p>
        Après chaque mission terminée, le Client peut noter le Dépanneur de 1 à 5 étoiles et laisser
        un commentaire. Les avis sont modérés <em>a posteriori</em> ; tout avis injurieux, diffamatoire
        ou manifestement faux sera supprimé sur simple demande motivée ou sur décision de DepannRoute.
      </p>

      <h2>8. Suspension &amp; résiliation</h2>
      <p>
        DepannRoute se réserve le droit de suspendre ou de résilier sans préavis le compte de tout
        utilisateur en cas de manquement grave aux présentes CGU, de fraude, de plainte récurrente
        ou de note moyenne inférieure au seuil minimal.
      </p>

      <h2>9. Propriété intellectuelle</h2>
      <p>
        Les contenus publiés par les utilisateurs restent leur propriété. En les publiant, ils
        accordent à DepannRoute une licence non exclusive d'utilisation pour le fonctionnement et
        la promotion de la Plateforme.
      </p>

      <h2>10. Modification des CGU</h2>
      <p>
        DepannRoute peut modifier les présentes CGU à tout moment. Les utilisateurs sont informés
        par email et/ou notification in-app 15 jours avant leur entrée en vigueur.
      </p>

      <h2>11. Droit applicable &amp; juridiction</h2>
      <p>
        Les présentes CGU sont soumises au droit français. Tout litige sera soumis aux tribunaux
        français compétents, sous réserve des règles spécifiques aux consommateurs.
      </p>
    </LegalShell>
  );
}
